<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="text-center m-t-lg"></div>
    </div>
  </div>
</div>
